module.exports = __webpack_public_path__ + "media/img/pages/companies/zurcher_kantonalbank-0cf0665664b08d42e5a8fd40e5204fbc.jpg";